// BASIC:
import React from "react"
import "./styles/writing.styles.sass"

// UTILITIES:
import { Container, Col, Row } from "react-bootstrap"
import { Link, graphql } from "gatsby"

// COMPONENTS:
import Layout from "../components/layout"
import SEO from "../components/seo"
import AsideViewer from "../components/aside-viewer/aside-viewer.comp"

// PAGE COMPONENT=>
const BlogIndex = ({ data, location }) => {
  const posts = data.allMarkdownRemark.nodes
  if (posts.length === 0) {
    return (
      <Layout location={location}>
        <SEO title="Salih/Writing : There is no posts yet!" />
        <Container>
          <h2 className="no-posts">There is no posts yet.</h2>
        </Container>
      </Layout>
    )
  }

  return (
    <Layout location={location}>
      <SEO title="Salih/Writing" />
      <Container fluid>
        <main className="page-wrapper writing">
            {/* list={[/!*" —All Posts"]} */}
            <AsideViewer heading={"Writing"} list={[]} />
            {/* aside */}
              {/*<section className="search">*/}
              {/*  <input type='search' placeholder='Search in all articles' />*/}
              {/*</section>*/}
                  <section className="posts-container">
                    <ul>
                      {posts.map(post => {
                        const title = post.frontmatter.title || post.fields.slug
                        const readingTime = post.frontmatter.timeToRead
                        return (
                          <li key={post.fields.slug} className="blog-post">
                            <Link to={post.fields.slug} itemProp="url" className="post-viewer-wrapper">
                              <article className="post-list-item" itemScope itemType="http://schema.org/Article">
                                <header>
                                  <h3 className="post-title">
                                    <span itemProp="headline">{title}</span>
                                  </h3>
                                  <p>
                                    <small className="post-release">{post.frontmatter.date}</small>
                                    <small> — </small>
                                    <small className="reading-time">{readingTime} Reading</small>
                                  </p>
                                </header>
                                <section className="description">
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: post.frontmatter.description || post.excerpt,
                                    }}
                                    itemProp="description"
                                  />
                                </section>
                              </article>
                            </Link>
                          </li>
                        )
                      })}
                    </ul>
                  </section>
                {posts.length !== 0 && (
                    <section className="popular-writing">
                      <h6>Popular writing</h6>
                      <small>No popular writings yet!</small>
                    </section>
                )}
            </main>
      </Container>
    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          description
          timeToRead
        }
      }
    }
  }
`
